module.exports = __webpack_public_path__ + "img/2025-03-12e_4.8bee97db.jpg";